import logo from "./logo.svg";
import "./App.css";
import { Routes as AppRoutes } from "./Routes";
import Home from "./pages/Home";
import DeleteAccount from "./pages/DeleteAccount";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Faqs from "./pages/Faqs";
import ContactUs from "./pages/ContactUs";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
function App() {
  return (
    <div className="App">
   
      <Router>
        <Routes>
          <Route element={<Layout />}>
            <Route path={AppRoutes.Default.path} element={<Home />} />
            <Route
              path={AppRoutes.DeleteAccount.path}
              element={<DeleteAccount />}
            />
            <Route
              path={AppRoutes.TermsAndConditions.path}
              element={<TermsAndConditions />}
            />
            <Route
              path={AppRoutes.PrivacyPolicy.path}
              element={<PrivacyPolicy />}
            />
            <Route
              path={AppRoutes.Faqs.path}
              element={<Faqs />}
            />
            <Route
              path={AppRoutes.Contact.path}
              element={<ContactUs />}
            />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
